"use client";

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/app/rootReducer";
import { AppDispatch } from "@/app/store";
import { fetchCompanyProfileAction } from "../../slices/companyProfileSlice";
import ServiceTitanIntegration from "../../../CompanyManagement/components/ServiceTitanIntegration/ServiceTitanIntegration";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const ServiceTitanSettings: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { companyProfile } = useSelector(
    (state: RootState) => state.companyProfile,
  );
  const { userAppSettings } = useSelector(
    (state: RootState) => state.userAppSettings,
  );

  useEffect(() => {
    dispatch(fetchCompanyProfileAction());
  }, [dispatch]);

  if (!companyProfile) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>ServiceTitan Integration</CardTitle>
          <CardDescription>Loading company profile...</CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>ServiceTitan Integration</CardTitle>
        <CardDescription>
          Connect your ServiceTitan account and map business units to trades.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ServiceTitanIntegration
          companyId={userAppSettings?.companyId}
          companyUuid={companyProfile.uuid}
        />
      </CardContent>
    </Card>
  );
};

export default ServiceTitanSettings;
